import { render, staticRenderFns } from "./AccessoSpid.vue?vue&type=template&id=7618095e&scoped=true"
import script from "./AccessoSpid.vue?vue&type=script&lang=js"
export * from "./AccessoSpid.vue?vue&type=script&lang=js"
import style0 from "./AccessoSpid.vue?vue&type=style&index=0&id=7618095e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618095e",
  null
  
)

export default component.exports